/*
 * Where the game server is. On the web and in the desktop app the page comes from it (or from
 * the desktop app's local proxy), so it is the page's own origin and requests go to /api and
 * /ws. The phone and tablet app (Capacitor, packages/mobile) carries the game inside it, so its
 * build names the server: VITE_SERVER in .env.app (vite --mode app).
 */

const configured = (import.meta.env.VITE_SERVER as string | undefined) ?? '';

/** The server's origin ('' : the page's own). */
export const SERVER_ORIGIN = configured.replace(/\/+$/, '');

/** The address of an API path ('/login', '/saves/x'). */
export function apiUrl(path: string): string {
  return `${SERVER_ORIGIN}/api${path}`;
}

/** The co-op relay's address (WebSocket). */
export function relayUrl(): string {
  if (SERVER_ORIGIN) return `${SERVER_ORIGIN.replace(/^http/, 'ws')}/ws`;
  return `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host || 'localhost'}/ws`;
}
